export class ProductSearchFormModel {
    public constructor(
        public catalogueNumber: string = null
    ) {

    }
}
